import { defineComponent as _defineComponent } from 'vue'
import InvCreateDialogFormCard from "@/views/Orders/Calendar/InvCreateDialogFormCard.vue";
  import {computed, PropType, reactive, toRefs, watch} from "vue";
  import {CalendarData} from "@/model/CalendarData";
  import {t} from "@/mixin/mixins";
  import moment from "moment/moment";
  import {integer} from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import {success} from "@/MessageUtils";
  import CalendarDataService from "@/service/CalendarDataService";
  import ModalDialog from "@/components/ModalDialog.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditMaxPosDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: () => false
    },
    clickedDay: {
      type: String,
      default: () => ""
    },
    clickedCalendarData: {
      type: Object as PropType<CalendarData>,
      default: () => undefined
    },
    defaultMaxPos: {
      type: Number,
      default: () => 90000
    }
  },
  emits: ["close", "saveCalendarData"],
  setup(__props, { emit }) {

const props = __props

  const errors = computed(() => {
    const map = new Map<string, string>();
    // @ts-ignore
    v$.value.$errors.forEach(error => map.set(error.$property, error.$message as string));
    return map;
  });

  

  const isVisible = computed({
    get: () => props.isVisible,
    set: (value) => {}
  });

  const clickedCalendarData = computed({
    get: () => props.clickedCalendarData,
    set: (value) => {}
  });

  

  const initialState = {
    originalCalendarData: null as CalendarData | null,
    currentCalendarData: null as CalendarData | null,
    serverErrors: []
  };

  const state = reactive({...initialState});

  toRefs(state);

  const rules = {
    currentCalendarData: {
      maxPositions: {
        integer
      }
    }
  };

  const v$ = useVuelidate(rules, state);

  const save = () => {
    v$.value.$reset();
    v$.value.$touch();

    if (!v$.value.$invalid && state.currentCalendarData) {
      const promise = CalendarDataService.processCalendarData(state.currentCalendarData);
      promise
        .then(response => {
          success(t("saveSuccessful"));
          emit("saveCalendarData", response.data);
        })
        .catch(error => {
          if (error.response.statusMessage === 422) {
            state.serverErrors = error.response.data;
          }
        });
    }
  };

  const close = () => {
    emit("close");
  };

  watch(() => state.originalCalendarData, (newValue, oldValue) => {
    if (newValue) {
      state.currentCalendarData = Object.assign({ }, JSON.parse(JSON.stringify(newValue)));
    } else {
      state.currentCalendarData = null;
    }
  }, { immediate: true, deep: true });

  watch(() => isVisible.value, (newValue, oldValue) => {
    if (isVisible.value) {
      if (clickedCalendarData.value) {
        state.originalCalendarData = Object.assign({}, JSON.parse(JSON.stringify(clickedCalendarData.value)));
      }
      else {
        const date = props.clickedDay ? moment(props.clickedDay).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        state.originalCalendarData = {
          id: 0,
          date: date,
          note: "",
          maxPositions: props.defaultMaxPos
        };
      }
    }
    else {
      state.originalCalendarData = null;
    }
  }, {immediate: true});

  const currentDateField = computed(() => {
    return state.currentCalendarData ? moment(state.currentCalendarData.date).format("DD.MM.YYYY") : "";
  });

  const currentMaxPos = computed({
    get: () => state.currentCalendarData ? state.currentCalendarData.maxPositions : props.defaultMaxPos,
    set: (newValue) => {
      if (state.currentCalendarData) {
        state.currentCalendarData.maxPositions = newValue;
      }
    }
  });

  const currentNote = computed({
    get: () => state.currentCalendarData ? state.currentCalendarData.note : "",
    set: (newValue) => {
      if (state.currentCalendarData) {
        state.currentCalendarData.note = newValue;
      }
    }
  });

return { __sfc: true,errors, props, isVisible, clickedCalendarData, emit, initialState, state, rules, v$, save, close, currentDateField, currentMaxPos, currentNote, InvCreateDialogFormCard, t, ModalDialog }
}

})